import { render, staticRenderFns } from "./GrmIcon.vue?vue&type=template&id=bbab802e&scoped=true&"
import script from "./GrmIcon.vue?vue&type=script&lang=js&"
export * from "./GrmIcon.vue?vue&type=script&lang=js&"
import style0 from "./GrmIcon.vue?vue&type=style&index=0&id=bbab802e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbab802e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbab802e')) {
      api.createRecord('bbab802e', component.options)
    } else {
      api.reload('bbab802e', component.options)
    }
    module.hot.accept("./GrmIcon.vue?vue&type=template&id=bbab802e&scoped=true&", function () {
      api.rerender('bbab802e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/icon/GrmIcon.vue"
export default component.exports